var map = {
	"./arrow_icon.png": 28032,
	"./first.png": 43801,
	"./left.png": 2328,
	"./logo.png": 22481,
	"./next.png": 29471,
	"./next2.png": 46220,
	"./nextcurrent.png": 65585,
	"./nextpage2.png": 78647,
	"./page3.png": 30779,
	"./page4.png": 49350,
	"./people_after.png": 68654,
	"./people_before.png": 56154,
	"./play.png": 19848,
	"./play_main.png": 69084,
	"./play_white.png": 87211,
	"./playbtn.png": 39492,
	"./prev.png": 87159,
	"./prev2.png": 36894,
	"./right.png": 38400,
	"./xi_image.png": 50348,
	"./xi_text.png": 27531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67112;